var _path, _g, _path2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEykoStreamToDb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "EykoStreamToDb_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 9,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0h9v9L7 7 2 8v2h2l1 2H1V0z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#EykoStreamToDb_svg__a)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2c0 .113-.05.26-.216.434-.168.177-.436.36-.805.523-.737.328-1.79.543-2.979.543-1.19 0-2.242-.215-2.979-.543-.369-.164-.637-.346-.805-.523C1.55 2.259 1.5 2.114 1.5 2c0-.113.05-.26.216-.434.168-.177.436-.36.805-.523C3.258.715 4.311.5 5.5.5c1.19 0 2.242.215 2.979.543.369.164.637.346.805.523.166.175.216.32.216.434zM9.5 10c0 .114-.05.26-.216.434-.168.177-.436.36-.805.523-.737.328-1.79.543-2.979.543-1.19 0-2.242-.215-2.979-.543-.369-.164-.637-.346-.805-.523-.166-.175-.216-.32-.216-.434 0-.113.05-.26.216-.434.168-.177.436-.36.805-.523.737-.328 1.79-.543 2.979-.543 1.19 0 2.242.215 2.979.543.369.164.637.346.805.523.166.175.216.32.216.434zM1.5 2v8M9.5 2v8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "EykoStreamToDb_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 9,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7l4 4h1l4-4v9l-4-4h-1l-4 4V7z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#EykoStreamToDb_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11.5,
    r: 2,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11.5,
    r: 4,
    stroke: "currentColor"
  }))));
}

export default SvgEykoStreamToDb;